import { Injectable } from "@angular/core";
import { Cargo } from "../interfaces/cargo";
import { Vehicle } from "../interfaces/vehicle";
import { Utils } from "../resources/utils";
import { AmountsCargoEnum } from "../enums/amountsCargo.enum";
import { HttpClient } from "@angular/common/http";
import { User } from "../interfaces/user";
import { environment } from "src/environments/environment";
import { Endpoints } from "../resources/endpoints";

@Injectable({ providedIn: 'root' })
export class UserService {

    constructor(
        private httpClient: HttpClient,
        private utils: Utils,
        private endpoints: Endpoints
    ) {

    }

    public getUserByDocument(document: string) {
        return this.httpClient.get<User>(
            `${environment.urlServerTeclogi}${this.endpoints.urlDetailUserByDocument}${document}`
        );
    }
}